
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from 'react';
import { NextSeo } from 'next-seo';
import { css } from '@emotion/react';
import ContestContainer from '@components/contest/ContestContainer';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Contest = () => {
  return (
    <>
      <NextSeo
        title="2024 월드 와이드 웹소설 공모전"
        description="W월드 W와이드 W웹소설 만렙 작가님을 찾습니다! 문화체육관광부 장관상과 총상금 1억원의 기회, 놓치지 마세요."
        openGraph={{
          title: '2024 월드 와이드 웹소설 공모전',
          description:
            'W월드 W와이드 W웹소설 만렙 작가님을 찾습니다! 문화체육관광부 장관상과 총상금 1억원의 기회, 놓치지 마세요.',
          url: 'https://storyplay.com/contest',
          images: [
            {
              url: 'https://storyplay.com/assets/img_contest_og.jpg',
              width: 800,
              height: 400,
            },
          ],
        }}
      />
      <div css={container}>
        <ContestContainer />
      </div>
    </>
  );
};
const container = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export default Contest;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/contest/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  